<div class="main-container">
  <div class="logo-backBtn-container">
    <div class="logo-container">
      <div class="logo">
        <img width="205px" [src]="'../../../../../assets/Hayrick/logo/'+subdomain+'/logo-light.svg'" alt="Hayrick Logo" />
      </div>
    </div>
    <span class="empty"> </span>
  </div>
  <div class="passcode-box-container">
    <div class="passcode-box">
      <div class="text-container">
        <p class="text-2">Create a New Passcode</p>
        <p class="text-1">Enter your new passcode.</p>
        <p class="text-3">Your passcode should consist of 4 digits</p>
      </div>

      <form [formGroup]="passwordForm">
        <div class="password-input-container">
          <div class="p-field">
            <span class="p-float-label">
              <input maxlength="4" formControlName="passcode" id="passcode" class="password-input" placeholder="Passcode" type="password" />

            </span>
          </div>

          <div class="p-field">
            <span class="p-float-label">
              <input
                maxlength="4"
                formControlName="confirm"
                id="confirm"
                class="password-input"
                type="password"
                placeholder="Confirm Passcode"
                (keyup.enter)="submitNewUserPasscode()"
              />

            </span>
          </div>


          <span *ngIf="passwordForm.value.passcode !== passwordForm.value.confirm && passwordForm.value.confirm !== ''"
            ><label class="error">Your passcodes do not match</label></span
          >
        </div>
      </form>

      <div class="signinbutton">
        <button [disabled]="!passwordForm.valid" (click)="submitNewUserPasscode()" class="button">SUBMIT</button>
      </div>
    </div>
  </div>
</div>


